<template>
    <div>       
        <template>
            <el-row :gutter="30">
                <el-col :xs="24" :xl="16">
                    <el-card shadow="never">
                        <el-row :gutter="30">
                            <el-col>
                                <el-form-item :prop="`sessions[${index}].realNameValidType`" label="认证方式:" :rules="[{required: true, message: `请选择场次${index+1}至少1项实名认证方式`}]">
                                    <el-radio-group v-model="formData.realNameValidType" size="medium">
                                        <el-radio :label="1">证件二要素认证</el-radio>
                                        <el-radio :label="2">身份证人脸认证</el-radio>
										<el-radio :label="0">无须认证</el-radio>
                                    </el-radio-group>
                                </el-form-item>								
                            </el-col>                            
                        </el-row>
                    </el-card>
                </el-col>
            </el-row>
        </template>

    </div>
</template>

<script>
export default {
    props:{
        formData: {
            type: Object,
            default: null
        },
        index:{
            type:Number,
            default: 0
        }
    },
	
}
</script>

<style lang="scss" scoped>
.el-card{
    margin-bottom: 20px;
}
</style>